import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { BASE_URL } from '../../../constants/constants';
import { login02 } from '../../imagepath';
import { translateError } from '../../../utils/errorTranslations';

const ConfirmEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  const [formData, setFormData] = useState({
    email: email,
    code: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate
    const newErrors = {};
    if (!formData.code) {
      newErrors.code = 'Моля, въведете код за потвърждение';
    } else if (formData.code.length !== 6) {
      newErrors.code = 'Кодът трябва да съдържа 6 цифри';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${BASE_URL}api/auth/confirm-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          email: formData.email,
          code: formData.code
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Потвърждението не бе успешно');
      }

      alert('Имейлът е потвърден успешно! Можете да влезете в акаунта си.');
      navigate('/login');
    } catch (error) {
      console.error('Confirmation error:', error);
      setErrors({ submit: translateError(error.message) || 'Възникна грешка при потвърждението' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-wrapper login-body">
      <div className="container-fluid px-0">
        <div className="row">
          <div className="col-lg-6 login-wrap">
            <div className="login-sec">
              <div className="log-img">
                <img className="img-fluid" src={login02} alt="Logo" />
              </div>
            </div>
          </div>

          <div className="col-lg-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="login-right">
                  <div className="login-right-wrap">
                    <h2>Потвърдете имейл адреса си</h2>

                    <p className="text-muted mb-4">
                      Изпратихме код за потвърждение на имейл адреса: <strong>{formData.email}</strong>
                    </p>

                    <form onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label style={{ display: 'block', marginBottom: '8px' }}>
                          Код за потвърждение <span className="login-danger">*</span>
                        </label>
                        <input
                          className={'form-control ' + (errors.code ? 'is-invalid' : '')}
                          type="text"
                          name="code"
                          value={formData.code}
                          onChange={handleChange}
                          placeholder="123456"
                          maxLength="6"
                        />
                        {errors.code && <div className="invalid-feedback d-block">{errors.code}</div>}
                        <small className="text-muted d-block" style={{ marginTop: '4px' }}>
                          Въведете 6-цифрения код от имейла
                        </small>
                      </div>

                      {errors.submit && (
                        <div className="alert alert-danger" role="alert">
                          {errors.submit}
                        </div>
                      )}

                      <div className="form-group login-btn">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? 'Потвърждаване...' : 'Потвърди'}
                        </button>
                      </div>
                    </form>

                    <div className="next-sign">
                      <p className="account-subtitle">
                        Не получихте код? <Link to="/resend-confirmation">Изпрати отново</Link>
                      </p>
                      <p className="account-subtitle">
                        Вече имате потвърден акаунт? <Link to="/login">Вход</Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;
